import { without } from 'lodash'
import React, { FC, useCallback, useState } from 'react'
import useAsyncEffect from 'shared/hooks/use-async-effect'
import useSameObjectRef from 'shared/hooks/use-same-ref'
import { LoggedInUser } from 'shared/types/user'
import UserContext from './user'

type Props = {
    user: LoggedInUser
    isLoggedIn: boolean
}

const UserManager: FC<Props> = ({ isLoggedIn, user, children }) => {
    const [userFavorites, setUserFavorites] = useState<(string | number)[]>([])
    useAsyncEffect(async () => {
        // TODO fetch favorites when api is ready
        if (isLoggedIn && userFavorites.length === 0) {
            // const gifs = await favoritesByUser(user)
            // setUserFavorites(gifs.map(g => g.id))
        }
    }, [user, isLoggedIn])
    const addFavorite = useCallback(
        id => {
            if (userFavorites.indexOf(id) === -1) {
                setUserFavorites([...userFavorites, id])
            }
        },
        [userFavorites]
    )
    const removeFavorite = useCallback(id => setUserFavorites(without(userFavorites, id)), [userFavorites])
    const userValue = useSameObjectRef({ user, isLoggedIn, favorites: userFavorites, addFavorite, removeFavorite })
    return <UserContext.Provider value={userValue}>{children}</UserContext.Provider>
}

export default UserManager
